function PageBackgroundPattern({
    className = "",
    glowColor = "rgba(34,197,94,.20)",
    baseLineColor = "rgba(34,197,94,.08)",
    stripeColor = "rgba(255,50,50,.35)",
    opacity = 0.6,
}) {
    return (
        <div
            className={`pointer-events-none absolute inset-0 ${className}`}
            style={{
                opacity,
                backgroundImage: `radial-gradient(circle at 50% 0%, ${glowColor}, transparent 42%), repeating-linear-gradient(90deg, ${baseLineColor} 0, ${stripeColor} 1px, transparent 1px, transparent 140px)`,
            }}
            aria-hidden="true"
        />
    );
}

export default PageBackgroundPattern;
